import { calculateHoursSum } from '@/domain/mitarbeiter/features/anlageassistent/utils/calculateHoursSum';
import {
  type Monate,
  MONATE,
} from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/monate';
import { Tage } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/tage';
import dayjs from 'dayjs';

export function calculateMonatssoll({
  tagessoll,
  tage,
}: {
  tagessoll: string;
  tage: Array<Tage[keyof Tage]>;
}): Array<{ monat: Monate; soll: string }> {
  const allMonths = Object.keys(MONATE);
  const allDates = getAllDaysOfYear(dayjs().year());

  return allMonths.map<{ monat: Monate; soll: string }>((month, index) => {
    const daysInMonth = allDates.filter(
      (date) =>
        date.month() === index &&
        tage.includes((date.isoWeekday() - 1) as Tage[keyof Tage]),
    );

    const sum = calculateHoursSum(Array(daysInMonth.length).fill(tagessoll));
    return {
      monat: MONATE[month],
      soll: sum,
    };
  });
}

function getAllDaysOfYear(year: number): dayjs.Dayjs[] {
  const start = dayjs().year(year).startOf('year');
  const end = dayjs().year(year).endOf('year');
  const daysInYear = end.diff(start, 'day') + 1;

  return Array.from({ length: daysInYear }, (_, index) =>
    start.add(index, 'day'),
  );
}
